import { useForm } from 'react-hook-form';
import axios from "axios";
import Cookies from 'universal-cookie';
import ObtieneDatosCookies from '../tools/obtieneDatosCookiesUsuario.js';
import { useState } from 'react';
import Swal from 'sweetalert2';
import Modal from 'react-modal';
import { Spinner } from 'reactstrap';
import CargaMasiva from './CargaMasiva.jsx';
import GestorIncumbenciasDocentes from './GestorIncumbenciasDocentes.jsx';
import comprueboPermisos from '../tools/comprueboPermisos.js';

function FormEditaDocente(props) {
  const [muestroCargaMasiva, setMuestroCargaMasiva] = useState(false);
  const [spinnerCargando, setMuestroSpinnerCargando] = useState(false);
  const [veoEdicion, setVeoEdicion] = useState(false);
  const [veoIncumbencias, setVeoIncumbencias] = useState(false);

  const cookies = new Cookies();
  const ID = cookies.get('id');

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: "90%",
      maxWidth: "900px",
      maxHeight: "90vh",
      overflow: "hidden",
      padding: "20px",
      borderRadius: "8px"
    },
  };

  const parametro = props.datos || {};
  const usuario = ObtieneDatosCookies() || {};

  const salgo = () => { props.myID && props.myID(""); };

  const store = async (data) => {
    data.usuarioID = usuario.id || null;

    try {
      Swal.fire({
        title: 'Creando docente...',
        text: 'Por favor, espere un momento',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      const respuesta = await axios.post(
        'https://wwwa.isepsantafe.net.ar/expedientes/docentes/creaDocente/',
        data
      );

      Swal.close();

      if (respuesta.data.success) {
        Swal.fire({
          title: '¡Éxito!',
          text: `Docente creado correctamente: ${respuesta.data.docente.docenteDni}`,
          icon: 'success',
          timer: 3000
        });
        salgo();
      } else {
        Swal.fire({
          title: 'Error',
          text: respuesta.data.message || 'No se pudo crear el docente',
          icon: 'error'
        });
      }

    } catch (error) {
      Swal.close();
      Swal.fire({
        title: 'Error al crear docente',
        text: error.response?.data?.message || error.message,
        icon: 'error'
      });
    }
  };

  const actualizoDocente = async (data) => {
    if (!parametro?.docenteDni) return;

    try {
      Swal.fire({
        title: 'Actualizando docente...',
        text: 'Por favor, espere un momento',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });
data.usuarioModifica=usuario.identificacion
      const respuesta = await axios.put(
        'https://wwwa.isepsantafe.net.ar/expedientes/docentes/actualizaDocente/' + parametro.docenteDni,
        data
      );

      Swal.close();

      queHago(respuesta.data);

    } catch (error) {
//       console.log(error)
      Swal.close();
      Swal.fire({
        title: 'Error al actualizar docente',
        text: error.response?.data?.message || error.message,
        icon: 'error'
      });
    }
  };

  const queHago = (respuesta) => {
//     console.log(respuesta)
    if (respuesta?.cambiosRegistrados>0) {
      Swal.fire({
        title: '¡Éxito!',
        text: `Docente actualizado correctamente: ${respuesta.docente?.docenteDni || ''}`,
        icon: 'success',
        timer: 3000
      });
    } else {
      Swal.fire({
        title: 'Error',
        text: respuesta?.message || 'Algo falló, consulte con el área técnica',
        icon: 'error'
      });
    }
  };

  const { register, formState: { errors }, handleSubmit, reset } = useForm({
    defaultValues: parametro
  });

  const onSubmit = (data) => {
    if (parametro && parametro.usuarioID) {
      actualizoDocente(data);
    } else {
      store(data);
    }
  };

  const closeModalInformeDocentes = () => { };

  return (
    <>
      <div>

        {/* Modal de carga masiva */}
        <Modal
          isOpen={muestroCargaMasiva}
          onRequestClose={closeModalInformeDocentes}
          style={customStyles}
          ariaHideApp={false}
        >
          <CargaMasiva myID={() => setMuestroCargaMasiva(false)} />
          {spinnerCargando && <>Cargando Docentes...<Spinner /></>}
        </Modal>

        {parametro?.docenteDni && (
          <div style={{ marginBottom: "15px", fontWeight: "bold", color: "#333" }}>
            Trabajando con: {parametro.docenteApellido}, {parametro.docenteNombres} - DNI: {parametro.docenteDni}
          </div>
        )}

        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "15px" }}>
          
          {comprueboPermisos(usuario.funcion,"Puedo Editar Docente")?<><button
            className={`btn ${veoEdicion ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => {
              setVeoEdicion(true);
              setVeoIncumbencias(false);
            }}
          >
            Edición Datos
          </button></>:""}
           {comprueboPermisos(usuario.funcion,"Modifico Incumbencias al Docente")?<> <button
            className={`btn ${veoIncumbencias ? "btn-success" : "btn-outline-success"}`}
            onClick={() => {
              setVeoIncumbencias(true);
              setVeoEdicion(false);
            }}
          >
            Gestión de Incumbencias Docentes
          </button></>:""}

         
        </div>

        {veoEdicion && (
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='input-group-text'>
              <div className="form-floating mb-3">
                <input type="text" className="form-control" placeholder="Apellido"
                  {...register('docenteApellido', { required: true, minLength: 2 })} />
                <label>Apellido</label>
              </div>

              <div className="form-floating mb-3">
                <input type="text" className="form-control" placeholder="Nombres"
                  {...register('docenteNombres', { required: true, minLength: 3 })} />
                <label>Nombres</label>
              </div>

              <div className="form-floating mb-3">
                <input type="mail" className="form-control" placeholder="email"
                  {...register('docenteEmail')} />
                <label>Email</label>
              </div>

              {/* DNI — AHORA BLOQUEADO SI EXISTE */}
              <div className="form-floating mb-3">
                <input
                  type="number"
                  className="form-control"
                  placeholder="dni"
                  disabled={!!parametro?.docenteDni}
                  {...register('docenteDni')}
                />
                <label>DNI</label>
              </div>
            </div>

            <div className="row">
              <div className='input-group-text'>
                <div className="form-floating mb-3">
                  <input type="number" className="form-control" placeholder="Celular"
                    {...register('docenteTelefono')} />
                  <label>Celular</label>
                </div>

                <div className="form-floating mb-3">
                  <input type="text" className="form-control" placeholder="Domicilio"
                    {...register('docenteDomicilio')} />
                  <label>Domicilio</label>
                </div>

                <div className="form-floating mb-3">
                  <select className="form-select" {...register('docenteEstado', { required: true })}>
                    <option value="Activo">Activo</option>
                    <option value="Inactivo">Inactivo</option>
                  </select>
                  <label>Estado</label>
                </div>

                <div className="form-floating mb-3">
                  <select className="form-select" {...register('docenteTipo', { required: true })}>
                    <option defaultValue value="Policia Actividad">Policia Actividad</option>
                    <option value="Policia Retirado">Policia Retirado</option>
                    <option value="Personal Civil">Personal Civil</option>
                  </select>
                  <label>Tipo</label>
                </div>
              </div>

              <div className='input-group-text' style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                {parametro?.usuarioID ?
                  <input type="submit" value="Actualizar" className="btn btn-success" /> :
                  <input type="submit" value="Crear Docente" className="btn btn-primary" />}
                <button type="button" className="btn btn-danger" onClick={salgo}>Cancelar</button>
              </div>
            </div>
          </form>
        )}

        {veoIncumbencias && parametro?.docenteDni && (
          <GestorIncumbenciasDocentes dniConstante={parametro.docenteDni} />
        )}

      </div>
    </>
  );
}

export default FormEditaDocente;
